module.exports = __webpack_public_path__ + "img/wx_pay_tip.7cb9e946.png";